if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.tab-button');
      this.contents = this.querySelectorAll('.tab-content');

      this.buttons.forEach((btn, index) => {
        btn.addEventListener('click', () => this.switchTab(index));
      });
    }

    switchTab(index) {
      this.buttons.forEach(b => b.classList.remove('active'));
      this.contents.forEach(c => c.classList.remove('active'));
      
      this.buttons[index].classList.add('active');
      this.contents[index].classList.add('active');
    }
  }
  customElements.define('tabs-component', TabsComponent);
}
